import { render, staticRenderFns } from "./InventorySurplusRecord.vue?vue&type=template&id=102a5a82&scoped=true"
import script from "./InventorySurplusRecord.vue?vue&type=script&lang=js"
export * from "./InventorySurplusRecord.vue?vue&type=script&lang=js"
import style0 from "./InventorySurplusRecord.vue?vue&type=style&index=0&id=102a5a82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102a5a82",
  null
  
)

export default component.exports